import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import Link from 'next/link';
import { Col, Row, Spinner, Button } from 'reactstrap';
import dayjs from 'dayjs';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import { X, Users, Eye, EyeOff } from 'react-feather';

import { useUser, useViewMode } from 'hooks/index';
import useI18n from 'hooks/use-i18n';
import { fetchEvent } from 'store/calendar/index';
import userEventApi from 'api/userEventApi';
import sessionUserApi from 'api/sessionUserApi';
import {
  USER_ROLES,
  USER_EVENT_TYPE,
  UNIT_TYPE,
  CONFERENCE_TYPE,
  USER_ROOM_STATUS,
} from 'constants/constants';
import { handleToastError } from 'helpers/index';
import { openAccessCode, openRecorded } from 'store/modal/index';
const ZoomApp = dynamic(
  () => import('../../../Course/Unit/components/ContentCalendar/zoomInside'),
  {
    ssr: false,
  },
);
import { useSelectedEvent } from 'hooks/calendar/index';
import styles from 'styles/Calendar.module.scss';
import FooterLearner from './FooterLearner';
import classnames from 'classnames';
import FooterAdmin from './FooterAdmin';
import { useSettingConferences } from '../../../../hooks/settings';
import {
  dateConversion,
  formatDDMMHHmm,
  titleExtensionWithTimeZone,
} from '../../../../helpers/format-time';
import unitCourseApi from '../../../../api/unitCourseApi';
import { getColor, getColorText, getThemeColor } from 'store/settings';
import ModalZoom from '../../../Course/Unit/components/ContentCalendar/modalZoomLink';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import styled from '@emotion/styled';
import calendarData from 'api/userEventApi';
import { getSelectedCentre } from 'store/master';
const AUDIENCE_ICON = {
  PRIVATE: {
    icon: <EyeOff size={16} />,
    tooltip: 'This is a private event',
  },
  CUSTOM: {
    icon: <Users size={16} />,
    tooltip: 'Everybody can see this event',
  },
  PUBLIC: {
    icon: <Eye size={16} />,
    tooltip: 'Only specific users can see this event',
  },
};

const ViewEvent = ({ onEditEvent, eventId, onClosePopover }) => {
  const viewMode = useViewMode();
  const dispatch = useDispatch();
  const i18n = useI18n();
  const [zoom, setZoom] = useState(false);
  const selectedEvent = useSelectedEvent();
  const conferenceType = useSettingConferences();
  const [zoomLink, setZoomLink] = useState();
  const [openZoom, setOpenZoom] = useState(false);
  const [lessonDatas, setLessonDatas] = useState([]);
  const selectedCentre = useSelector(getSelectedCentre);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  // fix show duplicate popovers
  const popovers = document.getElementsByClassName('popover-arrow-container');
  if (popovers?.length > 1 && popovers?.[0]?.style?.display !== 'none') {
    popovers[1].style.display = 'none';
  }

  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  const themeStatus = useSelector(getThemeColor);
  const Stylescal = styled.div`
    .btn-danger {
      border-color: ${colorStatus} !important;
      background-color: ${colorStatus} !important;
      color: ${colorTextStatus} !important;
    }
    .btn-danger:hover {
      background-color: #ffffff !important;
      color: ${colorStatus} !important;
      border-color: ${colorStatus} !important;
    }
  `;

  const time = selectedEvent?.time;
  const type = selectedEvent?.type;
  const unit = selectedEvent?.unit;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const userLoggedIn = useUser();

  const handleShowEditEvent = () => {
    onEditEvent();
    onClosePopover();
  };

  const onToggle = async () => {
    setOpenZoom(false);
  };

  const handleRouteEdit = async () => {
    try {
      if (unit?.course && unit?._id) {
        if (type !== UNIT_TYPE.CLASSROOM) {
          const params = {
            id: unit?._id,
          };
          const response = await unitCourseApi.getUnit(params);
          if (response?.events?.length === 1) {
            await Router.push(
              `/course/${unit?.course?._id}/add-live-training?id=${unit?._id}`,
            );
            return;
          }
        }
        await Router.push(
          `/course/${unit?.course?._id}/${
            type === UNIT_TYPE.CLASSROOM ? 'add-classroom' : 'add-live-training'
          }/${unit?._id}`,
        );
      }
    } catch (error) {
      handleToastError(error, i18n);
    }
  };

  const handleEdit = () => {
    if (type === USER_EVENT_TYPE.EVENT) {
      handleShowEditEvent();
    } else {
      handleRouteEdit();
    }
  };

  const handleRegister = async () => {
    try {
      setIsSubmitting(true);
      const data = {
        session: selectedEvent?._id,
        unit: selectedEvent?.unit?._id,
        user: userLoggedIn._id,
      };

      await sessionUserApi.create(data);
      dispatch(
        fetchEvent({
          eventId: eventId,
        }),
      );
      showToastSuccess('Registration successful!');
      setIsSubmitting(false);
    } catch (e) {
      handleToastError(e, i18n);
      setIsSubmitting(false);
    }
  };

  const handleUnregister = async () => {
    try {
      setIsSubmitting(true);
      await sessionUserApi.delete(selectedEvent?.sessionUserId);

      dispatch(
        fetchEvent({
          eventId,
        }),
      );
      showToastSuccess('Unregistration successful!');
      setIsSubmitting(false);
    } catch (e) {
      handleToastError(e, i18n);
      setIsSubmitting(false);
    }
  };
  const getDetails = async () => {
    try {
      let begin = new Date(eventId);
      begin.setDate(begin.getDate() - 1);

      let param = {
        begin: moment(begin).format('YYYY-MM-DD') + 'T18:30:00.000Z',
        end: moment(eventId).format('YYYY-MM-DD') + 'T18:29:00.000Z',
        types: `${USER_EVENT_TYPE.EVENT},${USER_EVENT_TYPE.WEBINAR},${USER_EVENT_TYPE.CLASSROOM}`,
      };
      if (selectedCentre?._id) {
        param.courseCentre = selectedCentre?._id;
      }
      const response = await calendarData.getAll(param);
      setLessonDatas(response);
      // setDisableStatus(true);
    } catch (error) {
      handleToastError(error);
    }
  };

  const closeHandler = () => {
    onClosePopover();
  };

  const handleJoinRoom = async () => {
    if (metaData?.zoomInside) {
      setZoom(true);
    } else {
      if (selectedEvent?.accessCodeRequired) {
        return dispatch(openAccessCode(eventId));
      }

      try {
        setIsSubmitting(true);
        if (conferenceType === CONFERENCE_TYPE.ZOOM) {
          const payload = await userEventApi.getLink(eventId);
          if (payload.data) {
            setOpenZoom(true);
            setZoomLink(payload.data);
          }
        } else {
          const link = await userEventApi.getLinkBBB(eventId);
          if (link) {
            setOpenZoom(true);
            setZoomLink(link);
          }
        }
        setIsSubmitting(false);
      } catch (e) {
        handleToastError(e, i18n, undefined, true);
        setIsSubmitting(false);
      }
    }
  };

  // const handleJoinRoom = async () => {
  //   setZoom(true);
  // };
  const renderRecorded = () => {
    if (
      selectedEvent?.recorded?.length > 0 &&
      viewMode !== USER_ROLES.LEARNER
    ) {
      return (
        <button
          className="btn-bg-color"
          onClick={() =>
            dispatch(
              openRecorded({
                data: selectedEvent?.recorded,
                title: selectedEvent?.name,
              }),
            )
          }
          style={{
            backgroundColor: `${colorStatus}`,
            color: `${colorTextStatus}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'white';
            e.target.style.borderColor = colorStatus;
            e.target.style.color = colorStatus;
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = colorStatus;
            e.target.style.color = colorTextStatus;
          }}
        >
          Recorded
        </button>
      );
    }
  };

  const formatHandler = (time, title) => {
    const timeStart = new Date(time?.begin);
    const timeEnd = new Date(time?.end);
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnd);
    let data = `${title}  ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.strTime}`;
    return data;
  };
  const listShow =
    type === USER_EVENT_TYPE.EVENT
      ? [
          {
            label: 'When',
            value: time?.begin
              ? `${formatDDMMHHmm(time?.begin)} - ${formatDDMMHHmm(time?.end)}`
              : '',
          },
          // {
          //   label: 'Organizer',
          //   value: ''
          // },
          {
            label: 'Description',
            value: selectedEvent?.description,
          },
        ]
      : [
          {
            label: 'When',
            value: time?.end
              ? `${formatDDMMHHmm(time?.begin)} - ${formatDDMMHHmm(time?.end)}`
              : '',
          },
          {
            label: 'Course',
            value: selectedEvent?.unit?.course?.name,
            name: 'course',
            path: `/course/${selectedEvent?.unit?.course?._id}`,
          },
          {
            label: 'Unit',
            value:
              (selectedEvent?.type == 'WEBINAR' ||
                selectedEvent?.type == UNIT_TYPE.LIVESTREAMING) &&
              selectedEvent?.titleExtenstion
                ? selectedEvent?.name +
                  ' ' +
                  titleExtensionWithTimeZone(
                    selectedEvent?.time?.begin,
                    selectedEvent?.time?.end,
                    selectedEvent?.timezone,
                  )
                : (selectedEvent?.type == 'WEBINAR' ||
                    selectedEvent?.type == UNIT_TYPE.LIVESTREAMING) &&
                  selectedEvent?.importLesson === true
                ? formatHandler(selectedEvent.time, selectedEvent.name)
                : selectedEvent?.unit?.title,
            name: 'unit',
            path: `/course/${selectedEvent?.unit?.course?._id}/unit/${selectedEvent?.unit?._id}`,
          },
          {
            label: 'Instructor',
            value: selectedEvent?.instructor?.fullName,
          },
          {
            label: 'Location',
            value: selectedEvent?.location?.name ? (
              <span>
                {selectedEvent?.location?.name}{' '}
                <i>
                  (capacity:
                  {selectedEvent?.location?.capacity})
                </i>
              </span>
            ) : (
              ''
            ),
          },
          {
            label: 'Description',
            value: selectedEvent?.description,
          },
        ];

  useEffect(() => {
    if (eventId) {
      dispatch(
        fetchEvent({
          eventId,
        }),
      );
    }
  }, [eventId]);

  const isLearner =
    userLoggedIn?.roles?.length === 1 &&
    userLoggedIn?.roles[0] === USER_ROLES?.LEARNER;
  const isShowRegister =
    viewMode === USER_ROLES.LEARNER &&
    type === USER_EVENT_TYPE.WEBINAR &&
    !isLearner;
  const isStart =
    viewMode !== USER_ROLES.LEARNER &&
    selectedEvent?.instructor?._id === userLoggedIn?._id;
  const isPrivacy = type === USER_EVENT_TYPE.EVENT && selectedEvent?.privacy;
  const isEdit = selectedEvent?.editable;

  const isShowFooterAdmin =
    viewMode !== USER_ROLES.LEARNER && isEdit && !isLearner;
  const isShowFooterLearner = isLearner && type === USER_EVENT_TYPE.WEBINAR;

  return (
    <div className={styles.popoverContainer}>
      {selectedEvent?.isLoading ? (
        <div className="p-5 text-center">
          <Spinner style={{ color: `${themeStatus}` }} />
        </div>
      ) : (
        <>
          <div className={styles.popoverHeader}>
            <h4 className="mb-0 w-100">
              {(selectedEvent?.type == 'WEBINAR' ||
                selectedEvent?.type == UNIT_TYPE.LIVESTREAMING) &&
              selectedEvent?.titleExtenstion
                ? selectedEvent?.name +
                  ' ' +
                  titleExtensionWithTimeZone(
                    selectedEvent?.time?.begin,
                    selectedEvent?.time?.end,
                    selectedEvent?.timezone,
                  )
                : (selectedEvent?.type == 'WEBINAR' ||
                    selectedEvent?.type == UNIT_TYPE.LIVESTREAMING) &&
                  selectedEvent?.importLesson === true
                ? formatHandler(selectedEvent.time, selectedEvent.name)
                : selectedEvent?.unit?.title}
            </h4>
            {isPrivacy && (
              <>
                <div className={styles.privacyIcon} id="privacy">
                  {AUDIENCE_ICON?.[selectedEvent?.privacy]?.icon}
                </div>
              </>
            )}

            <div className={styles.close} onClick={onClosePopover}>
              <X size={20} />
            </div>
          </div>

          <div className={styles.popoverBody}>
            {listShow.map((item, index) => {
              if (!item.value) return;
              return (
                <Row key={index} className="d-flex">
                  <Col sm={4}>
                    <strong>{item.label}</strong>
                  </Col>
                  <Col sm={8}>
                    {item?.name === 'unit' || item?.name === 'course' ? (
                      <div className="words-breaks">
                        <a onClick={() => Router.push(item.path)}>
                          {item.value}
                        </a>
                      </div>
                    ) : (
                      <span className="text-break">{item.value}</span>
                    )}
                  </Col>
                </Row>
              );
            })}
          </div>
          <div>
            <>
              {metaData?.zoomInside && zoom && (
                <ZoomApp
                  closeHandler={closeHandler}
                  event={selectedEvent?.unit}
                  id={eventId}
                  status={selectedEvent.roomStatus}
                  disabled={
                    selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING
                      ? false
                      : true
                  }
                  isLiving={
                    selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING
                      ? true
                      : false
                  }
                />
              )}
            </>
          </div>
          <div
            className={classnames('d-flex justify-content-between m-1 pb-1')}
          >
            {isShowRegister &&
              selectedEvent?.optionUser == 'REGISTRY' &&
              (metaData?.cmsHomePage ? selectedEvent?.isUnitAccess : true) &&
              (selectedEvent?.registered ? (
                <Stylescal>
                  <Button.Ripple
                    className="round"
                    color="danger"
                    onClick={handleUnregister}
                    disabled={isSubmitting}
                  >
                    UnRegister
                  </Button.Ripple>
                </Stylescal>
              ) : (
                <Stylescal>
                  <Button.Ripple
                    className="round"
                    color="danger"
                    onClick={handleRegister}
                    disabled={isSubmitting}
                  >
                    Register
                  </Button.Ripple>
                </Stylescal>
              ))}
            {isShowRegister && (
              <div className="d-flex align-items-center mb-1">
                {selectedEvent?.registered && (
                  <Stylescal>
                    <Button.Ripple
                      className={classnames(
                        `round btn ${
                          selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING
                            ? 'btn-danger'
                            : 'btn-secondary disableButton'
                        }`,
                        styles[
                          selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING
                            ? ''
                            : 'disableButton'
                        ],
                      )}
                      // className="round"
                      // color="danger"
                      onClick={handleJoinRoom}
                      disabled={
                        (selectedEvent.roomStatus !==
                          USER_ROOM_STATUS.RUNNING) |
                        isSubmitting
                      }
                    >
                      Join Room
                    </Button.Ripple>
                  </Stylescal>
                )}
              </div>
            )}
          </div>
          {isShowFooterAdmin && (
            <FooterAdmin
              onEdit={handleEdit}
              onStartRoom={handleJoinRoom}
              isDisabled={selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING}
              isShowRegister={isShowRegister}
              isStart={isStart}
              renderRecorded={renderRecorded}
            />
          )}

          {isShowFooterLearner &&
            (metaData?.cmsHomePage ? selectedEvent?.isUnitAccess : true) && (
              <FooterLearner
                event={selectedEvent}
                isDisabled={
                  selectedEvent.roomStatus === USER_ROOM_STATUS.RUNNING
                }
                isSubmitting={isSubmitting}
                onJoinRoom={handleJoinRoom}
                onRegister={handleRegister}
                onUnregister={handleUnregister}
                renderRecorded={renderRecorded}
              />
            )}
        </>
      )}
      <ModalZoom open={openZoom} toggle={onToggle} link={zoomLink} />
    </div>
  );
};

ViewEvent.propTypes = {
  eventId: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
  onEditEvent: PropTypes.func.isRequired,
  onClosePopover: PropTypes.func.isRequired,
};

export default ViewEvent;
